<template>
  <div class="view contentBody">
    <div class="content">
      <div class="content-tab-box">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="item">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
      </div>
    </div>
  </div>
</template>
<script>
  import articlePannel from "./articlePannel.vue";
  import miniappPannel from "./miniappPannel.vue";
  import subscribePannel from "./subscribePannel.vue";

  let tabBox = {
    '名片小程序授权': {property: 'miniappPannel'},
    '服务号授权': {property: 'articlePannel'},
    '订阅消息配置': {property: 'subscribePannel'}
  }

  export default {
    name: "authorization",
    components: {
      articlePannel,
      miniappPannel,
      subscribePannel
    },
    data() {
      return {
        meaulistTab: this.meaulist.meaulistGet(this, tabBox),
        activeName: ""
      };
    },
    created() {
      this.inittab();
    },
    methods: {
      inittab() {
        this.activeName =
            this.$route.query.tab !== undefined
                ? this.$route.query.tab
                : "miniappPannel";
      },
      tabCurrentFn(index) {
        this.meaulistTab.firstTab = index
      }
    }
  };
</script>
